import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import Login from './Login'
import { Roles } from '../../models/roles'

const LoginRoutes = ({
  role,
  loggedIn,
  selectStore,
  temporaryPassword,
  token,
}) => (
  <Route
    key="/login"
    path="/login"
    render={() => {
      if (loggedIn && selectStore) {
        return <Redirect to="/store/select" />
      }
      if (temporaryPassword) {
        return <Redirect to={`/password/activate?token=${token}`} />
      }
      if (loggedIn) {
        switch (role) {
          case Roles.SUPER_USER:
          case Roles.STORE_SALES_LIMITED:
          case Roles.STORE_SALES:
            return <Redirect to="/apply" />
          case Roles.WAREHOUSE:
            return <Redirect to="/transactions" />
          default:
            return <Redirect to="/apply" />
        }
      }
      return <Login />
    }}
  />
)

LoginRoutes.propTypes = {
  role: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  selectStore: PropTypes.bool.isRequired,
  temporaryPassword: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired,
}

export default LoginRoutes
